import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import Cookies from "js-cookie";

interface Presiden {
  id: number;
  nama: string;
  jabatan: string;
  bidang: string;
  foto: string;
}

const DetailLogo: React.FC = () => {
  const { namaBidang } = useParams<{ namaBidang: string }>();
  const [data, setData] = useState<Presiden[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    try {
      const token = Cookies.get("token");
      const url = `${process.env.REACT_APP_API_BASE_URL}/api/presiden?bidang[]=${encodeURIComponent(namaBidang || "")}`;

      const res = await fetch(url, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (!res.ok) throw new Error("Gagal ambil data presiden");

      const result = await res.json();
      const items = Array.isArray(result) ? result : result.data ?? [];
      setData(items as Presiden[]);
    } catch (err) {
      console.error(err);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [namaBidang]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-40">
        <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-primary"></div>
      </div>
    );
  }

  if (!data.length) {
    return <div className="text-center py-10">Tidak ada data untuk bidang ini.</div>;
  }

  return (
    <div className="min-h-screen p-6 sm:p-10 bg-gradient-to-r from-white via-yellow-50 to-yellow-100">
      <div className="mb-12">
        <div className="mt-2 mb-5 flex justify-center">
          <img src="/images/pancasila.png" alt="" className="w-20 h-24" />
        </div>
        <h2 className="text-2xl max-sm:text-xl font-semibold text-yellow-800 mb-6 border-b-2 border-yellow-400 text-center">{namaBidang}</h2>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
          {data.map((item) => (
            <Link key={item.id} to={`/detailPageUtama/${item.id}`} className="bg-white rounded-2xl shadow-md hover:shadow-xl transition-shadow duration-300 p-3 flex flex-col items-center border border-yellow-200">
              <div className="max-sm:w-[135px] w-36 h-48 overflow-hidden rounded-xl border-2 border-yellow-400 shadow">
                <img src={item.foto} alt={item.nama} className="w-full h-full object-cover transform hover:scale-105 transition-transform duration-300" />
              </div>
              <h3 className="mt-4 text-lg font-semibold text-gray-800 text-center max-sm:text-sm">{item.nama}</h3>
              <p className="text-sm max-sm:text-xs text-gray-600 text-center">{item.jabatan}</p>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DetailLogo;
